const template = require('lodash/template');
const AtualizaInputs = require('./AtualizaInputs');
const UsuarioAprovadorInput = require('./UsuarioAprovadorInput');

function grupoAprovadorInput(container, json, usuarios) {
  const $container = $(container);
  const template_string = $('#grupo-aprovador').html().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
  const _template = template(template_string);

  if(!$container.length) {
    return;
  }

  let count = 0;
  let idGrupo = 0;

  $container.parent().on('click', '.add-grupo', function(event, jsonGrupo) {
    const etapa = this.dataset.etapaId;
    const condicaoFilho = $('[name="condicaoFilho[' + etapa + ']"]').val();

    count++;
    idGrupo++;

    $('#grupos-aprovadores-' + etapa).append(_template({
      etapa: etapa,
      grupo: idGrupo
    }));

    $('[name="condicaoFilho[' + etapa + ']"]').val(condicaoFilho);

    if(jsonGrupo) {
      $('[name="condicaoNeto[' + etapa + '][' + idGrupo + ']"]').val(jsonGrupo.condicaoFilho);
    }

    UsuarioAprovadorInput(
      '#usuarios-aprovadores-' + etapa + '-' + idGrupo,
      jsonGrupo ? jsonGrupo.filhas : null,
      usuarios
    );

    if (!jsonGrupo) {
      $('#usuarios-aprovadores-' + etapa + '-' + idGrupo + ' + .add').trigger('click');
    }

    AtualizaInputs.init();
  });

  $container.on('click', '.remove', function(e) {
    if (count <= 1) {
      return false;
    }

    count--;

    $(this).closest('.js-grupo-aprovador').remove();
  });

  if (json) {
    json.forEach(function(item, n) {
      $container.parent().find('.add-grupo').trigger('click', [item]);
    });
  }
}

module.exports = grupoAprovadorInput;
